import { ROLES } from "../../config/roles";
import { ROUTE_TYPES } from "../../config/routeTypes";

import * as Pages from "../../pages";

const routes = [
  // root
  {
    path: "/",
    exact: true,
    name: "Home",
    element: Pages.P_Home,
    type: ROUTE_TYPES.Public,
    scrollToTop: true,
  },
];

export default routes;
